'use strict';

let Form = require('./formClass');

let fb = {};

fb.defaultConfig = {};
fb.elements = {};

fb.getForm = function(config) {
  if (!fb.configIsValid(config)) {
    return;
  }

  return new Form(fb, config.elements, config.form);
};

fb.configIsValid = function(config) {
  if (undefined === config) {
    throw new Error('Config must be set');
  }

  if (undefined === config.elements) {
    throw new Error('Elements must be set');
  }

  return true;
};

fb.register = function(name, element) {
  if (undefined === fb.elements[name]) {
    fb.elements[name] = element;
  }
};

fb.unRegister = function(name) {
  if (undefined !== fb.elements[name]) {
    delete fb.elements[name];
  }
};

fb.setDefaultConfig = function(config) {
  if (config) {
    fb.defaultConfig = config;
  }
};

fb.getDefaultConfig = function() {
  return fb.defaultConfig;
};

module.exports = {
  'getForm': fb.getForm,
  'register': fb.register,
  'unRegister': fb.unRegister,
  'ElementMock': fb.ElementMock,
  'setFormClass': fb.setFormClass,
  'getFormClass': fb.getFormClass,
  'elements': fb.elements,
  'setDefaultConfig': fb.setDefaultConfig,
  'getDefaultConfig': fb.getDefaultConfig,
};
